<div class="h-screen w-full bg-blue-50">
  <div
    class="flex flex-col justify-center items-center h-full max-w-lg mx-auto gap-y-12 px-4"
  >
    <h1 class="text-3xl font-bold">Forgot Password</h1>
    @if (submitted() === false) {
      <p class="text-center">
        Enter your email address and we'll send you a link to reset your
        password.
      </p>
      <form
        class="flex flex-col justify-start items-stretch w-full gap-y-4"
        [formGroup]="form"
        (submit)="onSubmit()"
      >
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input
            matInput
            formControlName="email"
            type="email"
            placeholder="Email"
          />
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="form.valid === false"
          class="self-center"
        >
          Send Reset Link
        </button>
      </form>
    } @else {
      <p class="text-center">
        We've sent you an email with a link to reset your password. Please check
        your inbox.
      </p>
    }
    <a [routerLink]="['/login']" class="text-blue-500">Back to login</a>
  </div>
</div>
